<!-- Current Outages List Table -->
<div class="card table-container">
    <div class="card-body" id="c_cur_outages_card_body">
        <table id="c_cur_outages_table">
            <thead>
                <tr id="c_cur_outages_header" class="cust-table-header">
                    <th (click)="sort('itemName')"  style="flex: 0 0 100px;" id="itemName">
                        <em class="fa fa-sort"
                            [ngClass]="{'fas fa-sort-down': (column == 'itemName' && isDesc), 'fas fa-sort-up': (column == 'itemName' && !isDesc) }"
                            aria-hidden="true">
                        </em>
                        {{ 'OutagesList.itemName' | translate }}
                    </th>
                    <th (click)="sort('category')" style="flex: 0 0 100px;" id="category">
                        <em class="fa fa-sort"
                            [ngClass]="{'fas fa-sort-down': (column == 'category' && isDesc), 'fas fa-sort-up': (column == 'category' && !isDesc) }"
                            aria-hidden="true">
                        </em>
                        {{ 'OutagesList.categoryName' | translate }}
                    </th>
                    <th (click)="sort('itemType')" style="flex: 0 0 100px;" id="itemType">
                        <em class="fa fa-sort"
                            [ngClass]="{'fas fa-sort-down': (column == 'itemType' && isDesc), 'fas fa-sort-up': (column == 'itemType' && !isDesc) }"
                            aria-hidden="true">
                        </em>
                        {{ 'OutagesList.itemType' | translate }}
                    </th>
                    <th (click)="sort('status')" style="flex: 0 0 100px;" id="status">
                        <em class="fa fa-sort"
                            [ngClass]="{'fas fa-sort-down': (column == 'status' && isDesc), 'fas fa-sort-up': (column == 'status' && !isDesc) }"
                            aria-hidden="true">
                        </em>
                        {{ 'OutagesList.itemStatus' | translate }}
                    </th>
                    <th style="flex: 0 0 100px;"  id="inactiveTime">
                        {{ 'OutagesList.inactiveTime' | translate }}
                    </th>

                </tr>
            </thead>
            <tbody *ngIf="isOutageslist" appInfinteScroll (scrolledEnd)="scrollEnd()" (scrolledCur)="scrollCur()">
                <tr class="table-body" *ngFor="let outageItem of outagesBasicInfoResponse; let i=index;trackBy: trackByOutages"
                    id="c_cur_outages_table_body" [routerLink]="[getRouterPath(outageItem)]">
                    <td>{{ outageItem.itemName }}</td>
                    <td>{{ outageItem.categoryName }}</td>
                    <td>{{ outageItem.itemTypeName }}</td>
                    <td>{{ outageItem.itemStatus }}</td>
                    <td>{{ outageItem. inactiveTime }}</td>
                </tr>
            </tbody>
             <tbody *ngIf="!isOutageslist  && !isLoading && !spinnerStart">
                <tr class="norecords"> 
                    <td colspan="5" class="text-center">{{ 'CommonStrings.noRecords' | translate }}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <!-- Spinner -->
    <div class="text-center col-12" id="sd_store_item_loading" *ngIf="isLoading || spinnerStart">
        <div id="spinner" role="progressbar">
            <zsd-spinner></zsd-spinner>
        </div>
    </div>
</div>

<!-- On Scroll End Message-->
<div *ngIf="(scrollEndReached && outagesBasicInfoResponse?.length > 20) " class="text-center">
    <div class="card">
        <div class="card-body" id="c_no_request_message">
            {{ 'CommonStrings.endOfScroll' | translate }}
        </div>
    </div>
</div>